const SYSTEM_REQUEST = 'SYSTEM_REQUEST';
const SYSTEM_SUCCESS = 'SYSTEM_SUCCESS';
const SYSTEM_FAILURE = 'SYSTEM_FAILURE';





export const systemRequest = payload => ({
  type: SYSTEM_REQUEST,
  payload: payload
});

export const systemSuccess = payload => ({
  type: SYSTEM_SUCCESS,
  payload,
});

export const systemFailure = payload => ({
  type: SYSTEM_FAILURE,
  payload,
});

const initialState = {
  isFetched: false,
  fetching: false,
  error: null,
  system:null
};

export function systemReducer(state = initialState, action) {
  switch (action.type) {
    case SYSTEM_REQUEST:
    return {
      ...state,
      fetching: true,
    };
 
     
    case SYSTEM_SUCCESS:
   console.log('SYSTEM2', action.payload)
      return {
        ...state,
        error: null,
        fetching: false,
        isFetched: true,
        system: action.payload
      };
    case SYSTEM_FAILURE:
    
      return {
        ...state,
        fetching: false,
        isFetched: false,
        error: action.payload,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/system.js